import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Table, Button, Form, Input, Modal } from "antd";
import Popup from "../../components/Popup";
import "../../styles/components/approverForm.scss";
import { useSelector } from "react-redux";

import { showPopup, hidePopup } from "../../state/slices/generalSlice";
import useAxios from "../../hooks/useAxios";
import ViewingForm from "../Form/ViewingForm";
import PvCardList from "../DataView/PvCardList";

import DataView from "../DataView/DataView";

function ApproveTable({
  tableColumn,
  tableData,
  popupSlice,
  popupName,
  popupWidth,
  docuType,
  addtnlFormFields,
  addtnlContent,
  // formDetails,
  viewingDataConfig,
  approverId,
  approverposId,
  onRefresh,
}) {
  const [form] = Form.useForm();
  const fields = [
    ...(addtnlFormFields || []),
    { name: "submission_id", label: "Submission ID", hidden: true },
    { name: "approval_id", label: "Approval ID", hidden: true },
  ];

  const { dataView } = useSelector((state) => state.generalSlice);

  const dispatch = useDispatch();
  const { loading, fetchData } = useAxios();

  const handleApprove = async (values) => {
    const requestData = {
      ...values,
      employee_id: approverId,
      position_id: approverposId,
    };

    try {
      const result = await fetchData({
        url: "/approver/approve",
        method: "POST",
        data: requestData,
      });

      if (result) {
        console.log("Approval successful:", result);
        dispatch(hidePopup(popupName));
        onRefresh();
      }
    } catch (err) {
      console.error("Approval failed:", err);
    }

    dispatch(hidePopup(popupName));
    onRefresh();
  };

  const handleDeny = async (values) => {
    const requestData = {
      ...values,
      employee_id: approverId,
      position_id: approverposId,
    };

    try {
      const result = await fetchData({
        url: "/approver/deny",
        method: "POST",
        data: requestData,
      });

      if (result) {
        console.log("Approval successful:", result);
        dispatch(hidePopup(popupName));
        onRefresh();
      }
    } catch (err) {
      console.error("Approval failed:", err);
    }
    dispatch(hidePopup(popupName));
    onRefresh();
  };

  const [formData, setFormData] = useState([]);

  const [isDisabled, setIsDisabled] = useState(false);

  const handleRowClick = (record) => {
    setIsDisabled(record?.status !== "pending");
    setFormData(record);
    form.setFieldValue("submission_id", record?.submission_id);
    form.setFieldValue("approval_id", record?.approval_id);
    dispatch(showPopup(popupName));
  };

  return (
    <>
      <div className="approve">
        <DataView style={{ marginBottom: "12px" }} />

        {/* <Table
          columns={tableColumn}
          dataSource={[...tableData].reverse()}
          size="small"
          rowKey={(record) => record.id || record.key}
          onRow={(record) => ({
            onClick: () => {
              handleRowClick(record);
            },
          })}
          className="approve-table"
        /> */}

        {dataView === "table" ? (
          <Table
            dataSource={[...tableData].reverse()}
            columns={tableColumn}
            size="small"
            rowKey={(record) => record.id || record.key}
            onRow={(record) => ({
              onClick: () => {
                handleRowClick(record);
              },
            })}
            className="approve-table"
          />
        ) : (
          <PvCardList
            data={[...tableData].reverse()}
            columns={tableColumn}
            onRowClick={(record) => handleRowClick(record)}
            maxActiveRow={5}
          />
        )}
        <Popup
          isOpen={popupSlice}
          title={docuType + " Form"}
          onCancel={() => {
            dispatch(hidePopup(popupName));
          }}
          footer={null}
          className="approve-popup"
          width={popupWidth}
        >
          {typeof addtnlContent === "function" && addtnlContent(formData)}
          <ViewingForm viewingDataConfig={viewingDataConfig} data={formData} />
          <Form
            disabled={isDisabled}
            form={form}
            layout="horizontal"
            className="approve-popup-form"
            labelCol={{
              span: "7",
            }}
            labelAlign="left"
          >
            {fields.map((field) => (
              <Form.Item
                key={field.name}
                name={field.name}
                label={field.label}
                hidden={field.hidden}
              >
                <Input />
              </Form.Item>
            ))}
            <Form.Item className="approve-popup-form-buttons">
              <Button
                danger
                className="approve-buts"
                loading={loading}
                onClick={() => {
                  Modal.confirm({
                    title:
                      "Are you sure you want to disapprove this request? This action cannot be undone.",
                    okText: "Yes, Disapprove",
                    cancelText: "No, Cancel",
                    centered: true,
                    onOk: () => {
                      form.validateFields().then(handleDeny);
                    },
                  });
                }}
              >
                Disapprove
              </Button>
              <Button
                type="primary"
                className="approve-buts"
                loading={loading}
                onClick={() => {
                  Modal.confirm({
                    title:
                      "Are you sure you want to approve this request? This action cannot be undone.",
                    content: "",
                    okText: "Yes, Approve",
                    cancelText: "No, Cancel",
                    centered: true,
                    onOk: () => {
                      form.validateFields().then(handleApprove);
                    },
                  });
                }}
              >
                Approve
              </Button>
            </Form.Item>
          </Form>
        </Popup>
      </div>
    </>
  );
}

export default ApproveTable;
